import { render, staticRenderFns } from "./PBToken.vue?vue&type=template&id=0b24b4ac&scoped=true"
import script from "./PBToken.vue?vue&type=script&lang=js"
export * from "./PBToken.vue?vue&type=script&lang=js"
import style0 from "./PBToken.vue?vue&type=style&index=0&id=0b24b4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24b4ac",
  null
  
)

export default component.exports